export function makeAuthChannel() {
    return new BroadcastChannel('auth');
}
export function waitForRefreshed(chan, timeoutMs = 1500) {
    return new Promise((resolve) => {
        let settled = false;
        const onMsg = (e) => {
            const msg = e.data;
            if (msg && msg.type === 'REFRESHED' && !settled) {
                settled = true;
                chan.removeEventListener('message', onMsg);
                resolve(msg);
            }
        };
        chan.addEventListener('message', onMsg);
        const t = window.setTimeout(() => {
            if (!settled) {
                settled = true;
                chan.removeEventListener('message', onMsg);
                resolve(undefined);
            }
        }, Math.max(250, timeoutMs));
        // Safety: clear if promise resolved early
        const cleanup = () => window.clearTimeout(t);
        // Attach then to auto-clear
        Promise.resolve().then(cleanup).catch(cleanup);
    });
}
//# sourceMappingURL=auth-channel.js.map